// extracted by mini-css-extract-plugin
export default {"title":"Contract_title__lQ+B8","content":"Contract_content__CC52d"};